import { createEffect, createEvent, createStore } from "effector";
import { withPersist } from "effector-persist";
import { useStore } from "effector-react";

import { toast } from "components/Toast";
import signup from "../../services/signup";

import { StepsKeys } from "./Steps";

const INITIAL_VALUES = {
  status: "" as "pending" | "error" | "fulfilled" | "",
  values: {} as {
    [key: string]: any;
  },
};

type Store = typeof INITIAL_VALUES;
type Values = Store["values"];
type Statuses = Store["status"];

export const instance = withPersist(
  createStore<Store>(INITIAL_VALUES, {
    name: "CREDENCIAMENTO",
  })
);

export const actions = {
  set: createEvent<Values>("setValues"),
  setStatus: createEvent<Statuses>(""),
  sync: createEffect("sync", {
    handler: async (values: Values) => {
      await signup.create(values);
    },
  }),
};

export function useSignup() {
  const store = useStore(instance);

  function setValues(step: StepsKeys, values: Values) {
    actions.set({
      [step]: values,
    });
  }

  function getValues(step: StepsKeys) {
    return store.values[step];
  }

  async function onSync() {
    actions.setStatus("pending");
    await actions.sync(store.values);
  }

  return {
    status: store.status,
    getValues,
    setValues,
    onSync,
  };
}

instance
  .on(actions.set, (state, values) => ({
    ...state,
    values: {
      ...state.values,
      ...values,
    },
  }))
  .on(actions.setStatus, (state, status) => ({
    ...state,
    status,
  }))
  .on(actions.sync.fail, (state) => {
    toast(
      "Ocorreu um erro ao finalizar o cadastro, por favor tente novamente.",
      {
        type: "error",
      }
    );

    return {
      ...state,
      status: "error",
    };
  })
  .on(actions.sync.doneData, (_) => INITIAL_VALUES);
